import { Store } from '@ngrx/store';
import { setS3BucketFileNames, uploadDocumentsToS3 } from '@store/actions';
import { IFileMetaData } from '@store/reducers/document-upload/document-upload.reducer';

import { generateUniqueFileName } from './generate-unique-file-name.helper';

export function dispatchUploadToS3(store: Store, filesMetadata: IFileMetaData[]): void {
  const filesToUpload = filesMetadata.filter((file) => !file.s3BucketFileName);
  if (filesToUpload.length === 0) {
    return;
  }
  const s3FilesMetadata = filesToUpload.map((file) => ({
    ...file,
    s3BucketFileName: generateUniqueFileName(file.fileName),
  }));

  // Stamp the keys into state first. Callers dispatch Next() in the same tick, and Next
  // drives the draft PATCH — if we waited for uploadToS3$ to succeed, the draft would be
  // written without any S3 key and the files could never be restored. The success path
  // re-dispatches this action, which is idempotent.
  store.dispatch(
    setS3BucketFileNames({
      // Mirror the filter the success path uses (documents.effects.ts) so a payload entry
      // can never carry an empty objectURL — setS3BucketFileNames matches on objectURL with
      // no slice discriminator, so an empty one would overwrite every hydrated entry in all
      // three slices at once.
      payload: s3FilesMetadata
        .filter((file) => file.objectURL && file.s3BucketFileName)
        .map((file) => ({
          objectURL: file.objectURL,
          s3BucketFileName: file.s3BucketFileName,
        })),
    }),
  );
  store.dispatch(uploadDocumentsToS3({ filesMetadata: s3FilesMetadata }));
}
